module.exports = __webpack_public_path__ + "static/media/pig.3ac1af46.png";